<template lang="pug">
    .game-wrapper
        .game-preview
            .game-title
                .game-title__name {{ $i18n.t('elements.elements_datePicker_requestTariff') }}
            .game-content
                .game__label {{ $i18n.t(`billing.billing_tariff_${user.school.changeTariffRequest.nextTariffId}`) }}
                .game__label {{ $i18n.t('trainer.trainer_main_bonusGames') + ': ' + bonusGamesString }}
                .game__label {{ $i18n.t('templates.template_form_selectedCourses') + ': ' + coursesNamesString }}
</template>

<script>
    import CsInput from '../../../elements/CsInput';
    import CsButton from '@/elements/CsButton.vue';
    import { mapState } from 'vuex';
    import CourseApi from '@/api/course';

    const MENTAL_TYPE = 'mental-arithmetic';

    const MENTAL_IDS = [2, 3, 4, 5, 6, 7, 8, 19];

    export default {
        props: {
            profile: Object,
        },
        data() {
            return {
                showSchools: false,
                showTariffModal: false,
                courses: [],
            };
        },
        mounted() {
            this.getCourses();
        },
        methods: {
            getCourses() {
                if (this.courses.length) return;
                CourseApi.getCoursesForTariff()
                    .then(data => {
                        const nonMental = Object.values(data).filter(c => c.type !== MENTAL_TYPE && c.id !== 16);
                        nonMental.push({
                            id: '__MENTAL__',
                            name: 'Ментальная арифметика',
                            type: MENTAL_TYPE,
                        });
                        this.courses = nonMental;
                    })
                    .catch(e => {
                        console.log(e);
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            bonusGamesString() {
                if (this.user.school.changeTariffRequest.isBonusGameActive)
                    return this.$i18n.t('progress.progress_preview_statusOn');
                return this.$i18n.t('progress.progress_preview_statusOf');
            },
            coursesNamesString() {
                const idsObj = this.user.school.changeTariffRequest?.coursesIds;
                if (!idsObj || typeof idsObj !== 'object') return '';

                const ids = Object.values(idsObj)
                    .map(Number)
                    .filter(Boolean);
                if (!ids.length) return '';

                const names = [];

                this.courses.forEach(c => {
                    if (ids.includes(c.id)) names.push(c.name);
                });

                if (ids.some(id => MENTAL_IDS.includes(id)) && !names.includes('Ментальная арифметика')) {
                    names.push('Ментальная арифметика');
                }

                return names.join('; ');
            },
        },
        components: {
            CsButton,
            CsInput,
        },
    };
</script>
<style lang="scss" scoped>
    .game-wrapper {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
    .game-preview {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .game-title {
        font-size: 16px;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            font-size: 20px;
        }
    }

    .game__label {
        min-width: 0;
        font-size: 14px;
        line-height: 19px;
        margin-bottom: 0.5rem;
        @include media($lg) {
            font-size: 16px;
        }
    }

    .game-input {
        flex-grow: 5;
        width: 65px;
        @include media($md) {
            margin-left: 15px;
        }
        @include media($lg) {
            width: 200px;
        }
    }

    .game-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 10px;
        margin-top: 10px;
    }
</style>
